
import React from "react";
import { useSearchParams } from "react-router-dom";
import MenuBar from "@/components/MenuBar";
import InterviewFeed from "@/components/InterviewFeed";

const Proto1Page = () => {
  const [searchParams] = useSearchParams();
  const sponsorFilter = searchParams.get('annonse') || undefined;
  const sponsorPosition = searchParams.has('posisjon') 
    ? parseInt(searchParams.get('posisjon')!, 10) 
    : undefined;

  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-2 md:pt-4 pb-6">
        <InterviewFeed 
          forceRefresh={true} 
          sponsorFilter={sponsorFilter}
          sponsorPosition={sponsorPosition}
        />
      </div>
    </div>
  );
};

export default Proto1Page;
